export const fr = {
  title: 'Rapport de guerre de guildes',
  darkMode: 'Mode nuit',
  tower: 'Nom de la tour ou du joueur...',
  t1: 'T1',
  t2: 'T2',
  report: 'Rapport',
  firstHero: 'Votre premier héro',
  speed: 'Vitesse',
  hp: 'PV',
  cr: '% CR',
  outspeed: 'Dépassé?',
  outspeedDesc: "Est-ce qu'il a joué avant moi?",
  extraInfos: 'Informations supplémentaires...',
  heroesSaved: 'Les héros/vitesses sont sauvegardés localement',
  copyText: 'Copier le texte dans le presse papier',
  copyTextSL: 'Copier le texte dans le presse papier(une ligne)',
  reset: 'Vider le formulaire',
  copyToast: 'Texte copié!',
  resetToast: 'Le formulaire a été réinitialisé!',
  enemiesFirstHero: 'Premier héro',
  enemiesSecondHero: 'Second héro',
  enemiesThirdHero: 'Troisième héro',
  enemiesFirstArtifact: 'Premier artefact',
  enemiesSecondArtifact: 'Second artefact',
  enemiesThirdArtifact: 'Troisième artefact',
  setCounter: 'Set contre',
  setImmunity: 'Set immunité',
  formatHpK: 'k',
  crBonus: '% CR diminuée',
  crBonusDesc: 'Exemple : 30 si basar joue avant vous',
  crPush: '% CR augmentée',
  crPushDesc: 'Exemple : 25 si rose joue avant vous',
  crPushAlly: '% CR augmentée pour vos alliés',
  crPushAllyDesc: 'Exemple : 15 si votre général purrgis est attaqué par des ennemis',
};
